export enum TaskVisualStatus {
  NOT_ATTEMPTED_CREDENTIALS = 'NOT_ATTEMPTED_CREDENTIALS',
  NOT_ATTEMPTED_DOCUMENTS = 'NOT_ATTEMPTED_DOCUMENTS',
  NOT_ATTEMPTED_CREDENTIALS_DOCUMENTS = 'NOT_ATTEMPTED_CREDENTIALS_DOCUMENTS',
  NOT_ATTEMPTED_BANK = 'NOT_ATTEMPTED_BANK',
  NOT_ATTEMPTED_IRS = 'NOT_ATTEMPTED_IRS',
  COMPLETED_CREDENTIALS = 'COMPLETED_CREDENTIALS',
  COMPLETED_DOCUMENTS = 'COMPLETED_DOCUMENTS',
  COMPLETED_INSTANT = 'COMPLETED_INSTANT',
  COMPLETED_BANK = 'COMPLETED_BANK',
  COMPLETED_IRS = 'COMPLETED_IRS',
  IN_PROGRESS = 'IN_PROGRESS',
  ERROR = 'ERROR',
  SKIPPED = 'SKIPPED',
  SKIPPED_BANK_FINICITY = 'SKIPPED_BANK_FINICITY',
  SKIPPED_BANK_IDENTIFY_INCOMES = 'SKIPPED_BANK_IDENTIFY_INCOMES',
}
